
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/calculators",
      function () {
        return require("private-next-pages/cleartax.in/calculators/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/calculators"])
      });
    }
  